
<template>
  <div :class="'nav-frame ' + `n-frame-${mobile ? 'mobile' : 'web'}`">
    <nav :class="`nav-outer ${mobile ? 'nav-mobile' : 'nav-web'}`">
      <div
        v-for="(node, index) in allNodes"
        :class="`nav-node ${mobile ? 'mobile' : 'web'}-node`"
        :id="`${nodeIds[index]}${(nodes.includes(node) && !mobile) ? '-ani' : ''}`"
        @click="$router.push({path: parseRoute(node)})"
        @mouseover="hoverTitle = switchTitle(node)"
      >
      <v-popover offset="16" trigger="hover" placement="right">
        <img style="height:50px;" :src="switchUrl(node)"  v-if="nodes.includes(node)"/>
        <template slot="popover">
          <hover-component :options="{type:'mini', text: switchTitle(node)}"></hover-component>
        </template>
      </v-popover>
      </div>
    </nav>
  </div>

</template>

<script>

import { mapState } from 'vuex';

import Hover from '../hover/Hover';

export default {

  data(){
    return {
      mobile: false,
      allNodes: ['org', 'bldg', 'floor', 'room'],
      nodeIds: [
        'org-node',
        'bldg-node',
        'floor-node',
        'room-node'
      ],
      activeNode: '',
      hoverTitle: ''
    }
  },

  components: {
    'hover-component': Hover
  },

  computed: mapState({
    nodes: state => state.navNodes
  }),

  methods: {

    switchUrl(node){
      let img;
      switch (node) {
        case 'org':
          img = 'enterprise';
        break;
        case 'bldg':
          img = 'company';
        break;
        case 'floor':
          img = 'tilesWhite';
        break;
      }
      return node !== 'room'
        ? `https://brebe-s3-storage-matt.s3-eu-west-1.amazonaws.com/breezi-pro/${img}.png`
        : 'https://breezi-pro-assets.s3-eu-west-1.amazonaws.com/doorWhite.png';
    },

    animate(i, onOff){
      this.nodeIds[i] = onOff
        ? this.nodeIds[i] + '-ani'
        : this.nodeIds[i].substring(0, this.nodeIds[i].length - 4);
    },

    parseRoute(n){
      switch (n) {
        case 'org':
          return '/organization';
        break;
        case 'bldg':
          return `/building/${this.$store.state.buildingId}`;
        break;
        case 'floor':
          return this.mobile ? `/floor/${this.$store.state.floorIndex}` : `/heatmap/${this.$store.state.floorIndex}`;
        break;
      }
    },

    switchTitle(n){
      switch (n) {
        case 'org':
          return 'Organization';
        break;
        case 'bldg':
          return 'Building';
        break;
        case 'floor':
          return 'Floor';
        break;
        case 'room':
          return 'Room';
        break;
      }
    }

  },

  mounted(){
    this.mobile = this.$screen.breakpoint === 'sm' ? true : false;
  },

  watch: {
    '$screen.width': function(newData, oldData){
      this.mobile = this.$screen.breakpoint === 'sm' ? true : false;
    }
  }

}

</script>

<style>

.nav-frame {
  position: absolute;
  height: 100vh;
  width: 100px;
  left: 0px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  top: 0px;
  align-items: flex-start;
  /* justify-content: center;
  align-items; flex-start; */
}

.n-frame-mobile {
  bottom: 0px;
  top: calc(100%);
  height: 100px;
  width: 100%;
}

.n-frame-web {
}

.nav-outer {
  display: flex;
  justify-content: space-around;
  align-items: center;
  position: absolute;
  left: 0px;
}

.nav-node {
  height: 65px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.nav-mobile {
  width: 100%;
  height: 67.5px;
  bottom: 0px;
  position: fixed;
}

.nav-mobile .nav-node {
  width: 25%;
}

.nav-web {
  height: 400px;
  width: 100px;
  overflow: hidden;
  flex-direction: column;
  align-items: flex-start;
  /* top: calc(50% - 150px); */
}

.nav-web .nav-node {
  height: 24%;
  width: 15px;
  cursor: pointer;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
}

.nav-node img {
  height: 60%;
}

#org-node {
  background-color: #325468;
}

#bldg-node {
  background-color: #36627c;
}

#floor-node {
  background-color: #417c9d;
}

#room-node {
  background-color: #55a5d3;
}

#org-node-ani {
  background-color: #325468;
  animation: pulltab .25s forwards;
}

#bldg-node-ani {
  background-color: #36627c;
  animation: pulltab .25s forwards;
}

#floor-node-ani {
  background-color: #417c9d;
  animation: pulltab .25s forwards;
}

#room-node-ani {
  background-color: #55a5d3;
  animation: pulltab .25s forwards;
}

@keyframes pulltab {
  100% {
    width: 100%;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/util/Nav.vue